import { WORKFLOW_PREFIX } from 'Utils/constants';

import { PlanTypes } from './Billing';

const addPrefix = (path: string) => `${WORKFLOW_PREFIX}${path}`;

export const RoutePaths = {
  BASE_PATH: addPrefix(''),
  APPSUMO_THANKS: addPrefix('appsumo_thanks'),
  RESET: addPrefix('reset'),
  CONFIRM_EMAIL: addPrefix('confirm_email'),
  DOCUMENT_SIGN: addPrefix('documents/:documentId/sign'),
  EMBED_DOCUMENT: addPrefix('embedded/request/:documentId'),
  ACCEPT_INVITE: addPrefix('teams/:teamId/accept_invite'),
  REMINDERS_UNLINK: addPrefix('documents/:signerId/reminders_unlink'),
  INVOICE_DOWNLOAD: addPrefix('invoices/:invoiceId/download'),
  SIGNER_DOCUMENT_DOWNLOAD: addPrefix('documents/:documentId/:signerId/download'),
  SEPARATED_DOCUMENT_DOWNLOAD: addPrefix(
    'documents/:documentId/download-separated-document',
  ),
  DOCUMENT_ACTIVITIES_DOWNLOAD: addPrefix('documents/:documentId/download-activities'),
  DOCUMENT_DOWNLOAD: addPrefix('documents/:documentId/download'),
  ORIGINAL_DOCUMENT_DOWNLOAD: addPrefix('documents/:documentId/download-original'),
  FORM_REQUESTS_SEND: addPrefix('form-requests/:formRequestId/send'),
  LANDING_SIGNUP: addPrefix('new/flows/new-signup'),
  LANDING_DOCUMENT_UPLOADER: addPrefix('new/flows/uploader'),
  LANDING_DOCUMENT_EDITOR: addPrefix('new/flows/editor/:documentId'),
  LANDING_SIGNUP_CONFIRM: addPrefix('new/flows/welcome-doc'),
  LANDING_SIGNUP_THANKS: addPrefix('new/flows/thanks'),
} as const;

export const AuthorizedRoutePaths = {
  ...RoutePaths,
  SIGN: addPrefix('sign'),
  ONLY_ME: addPrefix('only-me'),
  ME_AND_OTHERS: addPrefix('me-and-others'),
  ONLY_OTHERS: addPrefix('only-others'),
  BULK_SEND: addPrefix('bulk-send'),
  UPSELL: addPrefix('upsell'),
  INTEGRATIONS: addPrefix('integrations'),
  TEAM: addPrefix('team'),
  ACTIVATE_TRIAL: addPrefix('activate-trial'),
  TRY_TRIAL: addPrefix('try-trial'),
  TRIAL_SUCCESS: addPrefix('welcome-trial'),
  TRIAL_FROM_FREE_SUCCESS: addPrefix('welcome-free-trial'),
  UPGRADE_PERSONAL_SUCCESS: addPrefix('welcome-personal'),
  UPGRADE_BUSINESS_SUCCESS: addPrefix('welcome-business'),
  START_PERSONAL_SUCCESS: addPrefix('personal-start'),
  START_BUSINESS_SUCCESS: addPrefix('business-start'),
  //Documents paths
  DOCUMENTS: addPrefix('documents'),
  DOCUMENTS_STATUS: addPrefix('documents/:status?'),
  DOCUMENT_PREVIEW: addPrefix('documents/:documentId/preview'),
  RECEIVED_DOCUMENTS: addPrefix('documents/received'),
  TRASH: addPrefix('documents/trash'),
  DOCUMENTS_EDIT: addPrefix('documents/:documentId/edit'),
  //Templates paths
  TEMPLATES: addPrefix('templates'),
  TEMPLATES_ACTIVE: addPrefix('templates/active'),
  TEMPLATES_CREATE: addPrefix('templates/create'),
  TEMPLATES_EDIT: addPrefix('templates/:templateId/edit'),
  TEMPLATES_STATUS: addPrefix('templates/:type/:status?'),
  //Form requests paths
  FORM_REQUESTS: addPrefix('form-requests'),
  FORM_REQUESTS_CREATE: addPrefix('form-requests/create'),
  FORM_REQUESTS_STATUS: addPrefix('form-requests/:status?'),
  FORM_REQUESTS_EDIT: addPrefix('form-requests/:formRequestId/edit'),
  //Settings paths
  SETTINGS: addPrefix('settings'),
  SETTINGS_COMPANY: 'company',
  SETTINGS_PROFILE: 'profile',
  SETTINGS_REQUEST_HISTORY: 'api/:apiKeyId/request_history',
  SETTINGS_API: 'api',
  SETTINGS_EDIT_SIGNATURE: 'edit-signature',
  SETTINGS_BILLING: 'billing',
  SETTINGS_BILLING_PLAN: 'billing/plan',
} as const;

export const UnauthorizedRoutePaths = {
  ...RoutePaths,
  SIGN_UP: addPrefix('signup'),
  CONFIRM_ACCOUNT: addPrefix('confirm-account'),
  CHANGE_PASSWORD: addPrefix('change_password'),
  LOGIN: addPrefix('login'),
  SIGN_UP_FREE: addPrefix('signup/free*'),
  SIGN_UP_BUSINESS: addPrefix('signup/business*'),
  SIGN_UP_PERSONAL: addPrefix('signup/personal*'),
  TWO_FACTOR: addPrefix('two-factor'),
  ABOUT: addPrefix('about'),
} as const;

export const settingsRedirectionMap = {
  [AuthorizedRoutePaths.SETTINGS_COMPANY]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_COMPANY}`,
  [AuthorizedRoutePaths.SETTINGS_PROFILE]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_PROFILE}`,
  [AuthorizedRoutePaths.SETTINGS_REQUEST_HISTORY]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_API}`,
  [AuthorizedRoutePaths.SETTINGS_API]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_API}`,
  [AuthorizedRoutePaths.SETTINGS_EDIT_SIGNATURE]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_EDIT_SIGNATURE}`,
  [AuthorizedRoutePaths.SETTINGS_BILLING]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_BILLING}`,
  [AuthorizedRoutePaths.SETTINGS_BILLING_PLAN]: `${AuthorizedRoutePaths.SETTINGS}/${AuthorizedRoutePaths.SETTINGS_BILLING_PLAN}`,
} as const;

export const slugUpgradeRoutesMap = {
  [PlanTypes.PERSONAL]: AuthorizedRoutePaths.UPGRADE_PERSONAL_SUCCESS,
  [PlanTypes.BUSINESS]: AuthorizedRoutePaths.UPGRADE_BUSINESS_SUCCESS,
} as const;

export const slugStartRoutesMap = {
  [PlanTypes.PERSONAL]: AuthorizedRoutePaths.START_PERSONAL_SUCCESS,
  [PlanTypes.BUSINESS]: AuthorizedRoutePaths.START_BUSINESS_SUCCESS,
} as const;
